export default __webpack_public_path__ + "static/media/sashi.c2d72d60.png";